import type { FC, ReactNode } from 'react'

import { useDictionary } from '@/lib/i18n'
import Reveal from '@/components/landing/reveal'
import SectionHeading from '@/components/landing/section-heading'

const SpecsSection: FC = (): ReactNode => {
    const t = useDictionary()
    const { specs } = t

    return (
        <section id='specs' aria-labelledby='specs-title' className='border-t border-border bg-black/25 py-24 sm:py-32'>
            <div className='mx-auto max-w-7xl px-5 sm:px-8'>
                <Reveal>
                    <SectionHeading id='specs-title' eyebrow={specs.eyebrow} title={specs.title} />
                </Reveal>

                <div className='mt-14 gap-5 lg:columns-2'>
                    {specs.groups.map((group, groupIndex) => (
                        <Reveal key={group.title} className='mb-5 break-inside-avoid'>
                            <div className='rounded-2xl border border-border bg-card/60 p-6 sm:p-8'>
                                <h3 className='display-heading flex items-center gap-3 font-heading text-2xl font-semibold uppercase tracking-tight text-foreground'>
                                    <span className='font-mono text-xs font-normal text-race-bright'>
                                        {String(groupIndex + 1).padStart(2, '0')}
                                    </span>
                                    {group.title}
                                </h3>

                                <dl className='mt-5 divide-y divide-border'>
                                    {group.rows.map((row) => (
                                        <div key={row.label} className='grid gap-1 py-3.5 sm:grid-cols-[10rem_1fr] sm:gap-6'>
                                            <dt className='text-sm text-muted-foreground'>
                                                {row.label}
                                            </dt>
                                            <dd className='text-sm leading-relaxed text-foreground'>
                                                {row.value}
                                            </dd>
                                        </div>
                                    ))}
                                </dl>
                            </div>
                        </Reveal>
                    ))}
                </div>

                <p className='mt-4 text-xs text-muted-foreground'>
                    {specs.note}
                </p>
            </div>
        </section>
    )
}

export default SpecsSection
